import { ApiResponse } from "apisauce";
import toast from "react-hot-toast";
import { Buffer } from "buffer";
import { format, parseISO } from "date-fns";
//@ts-ignore
import pako from "pako";

export const configApp = {
  api: process.env.REACT_APP_cnxAPI,
  seguridad: process.env.REACT_APP_cnxSeg,
  ambiente: process.env.REACT_APP_test === "true" ? "test_bi" : "produccion_bi",
  seguridad_v1: process.env.REACT_APP_cnxSegV1,
  url_reporte: process.env.REACT_APP_urlResp,
  url_powerBi: "https://api-bi.idmkt.mx/", //process.env.REACT_APP_urlBase,
};

export const reportTypeMap: Record<number, string> = {
  1: "ssrs",
  2: "power-bi",
  3: "power-bi-premium",
};

export const buildUrl = (
  id: number,
  url: string,
  idTipoReporte: number
) => {
  const reportType = reportTypeMap[idTipoReporte];

  return reportType
    ? `../../report/${id}/${reportType}`
    : `../../${url}`;
};



export const buildMenu = (
  items: any[],
  expand: Record<string, boolean>,
  expandSub: Record<string, boolean>,
  level = 0
): any[] =>
  items.map(item => {
    if (item.hijos?.length) {
      level === 0
        ? (expand[item.codigoVista] = false)
        : (expandSub[item.codigoVista] = false);
    }

    return {
      id: item.idVista,
      text: item.descripcion,
      key: item.codigoVista,
      url: buildUrl(item.idVista, item.url, item.idTipoReporte),
      children: item.hijos ? buildMenu(item.hijos, expand, expandSub, level + 1) : [],
    };
  });

export function cloneObjectWithRegExp(obj: any) {
  const clonedObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (value instanceof RegExp) {
        clonedObj[key] = new RegExp(value.source, value.flags);
      } else if (typeof value === "object") {
        clonedObj[key] = cloneObjectWithRegExp(value);
      } else {
        clonedObj[key] = value;
      }
    }
  }
  return clonedObj;
}
function isDateValid(date: string) {
  const dateValue = parseISO(date);
  const currentDate = new Date();
  return dateValue > currentDate;
}
function isEmailValid(email: string) {
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regexEmail.test(email);
}
function isPhoneNumberValid(phone: string) {
  const regex = /^\d{3}-\d{3}-\d{4}$/;
  return regex.test(phone);
}
function isNameValid(name: string) {
  const regex = /^[a-zA-ZáÁéÉíÍóÓúÚñÑ\s']+$/;
  return regex.test(name);
}
function isRfcValid(rfc: string) {
  // const regex =
  //   /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/;
  const regex = /^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/;
  return regex.test(rfc);
}
function isNssValid(nss: string) {
  const regex = /^\d{11}$/;
  return regex.test(nss);
}
function isCURPValid(curp: string) {
  var patron =
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
  var validado = curp.match(patron);

  if (!validado) {
    return false;
  }
}
function isOlder(birthdate: string) {
  const birthdateArr = birthdate.split("-");
  const year = parseInt(birthdateArr[0]);
  const month = parseInt(birthdateArr[1]);
  const day = parseInt(birthdateArr[2]);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();

  let age = currentYear - year;

  if (currentMonth < month || (currentMonth === month && currentDay < day)) {
    age--;
  }

  return age >= 18;
}


// ======================
// Helpers
// ======================
const setError = (field: any, message?: string): boolean => {
  field.error = true;
  field.textError = message ?? field.textError ?? "";
  return true;
};

const clearError = (field: any) => {
  field.error = false;
  field.textError = "";
};

// ======================
// Validators by type
// ======================
const validators: Record<string, (value: any, field: any) => boolean> = {
  text: (value, field) => {
    if (!value?.trim()) {
      return setError(field, "No se ha ingresado información");
    }

    if (field.expresion instanceof RegExp && !field.expresion.test(value)) {
      return setError(
        field,
        "No acepta caracteres especiales o campos vacíos"
      );
    }

    if (field.limit && value.length > field.limit) {
      return setError(
        field,
        `Se ha superado el límite de caracteres permitido (${field.limit})`
      );
    }

    clearError(field);
    return false;
  },

  select: (value, field) => {
    if (value === 0 || !value) {
      return setError(field);
    }
    clearError(field);
    return false;
  },

  multiSelect: (value, field) => {
    if (!Array.isArray(value) || value.length === 0) {
      return setError(field);
    }
    clearError(field);
    return false;
  },

  date: (value, field) => {
    const isNotValidate = field?.notValidate ?? false;

    if (isNotValidate) {
      if (!value) {
        return setError(field, "Ingresa una fecha");
      }
      clearError(field);
      return false;
    }

    if (!value || !isDateValid(value)) {
      return setError(field, "Fecha inválida");
    }

    clearError(field);
    return false;
  },

  number: (value, field) => {
    if (value <= 0) {
      return setError(field);
    }
    clearError(field);
    return false;
  },

  email: (value, field) => {
    if (value?.trim() && !isEmailValid(value)) {
      return setError(field, "Correo inválido");
    }
    clearError(field);
    return false;
  },

  phone: (value, field) => {
    if (value?.trim() && !isPhoneNumberValid(value)) {
      return setError(field, "Teléfono inválido");
    }
    clearError(field);
    return false;
  },

  name: (value, field) => {
    if (!value?.trim()) {
      return setError(field);
    }

    if (!isNameValid(value)) {
      return setError(field, "Valor inválido");
    }

    clearError(field);
    return false;
  },

  rfc: (value, field) => {
    if (value?.trim() && !isRfcValid(value)) {
      return setError(field, "RFC inválido");
    }
    clearError(field);
    return false;
  },

  nss: (value, field) => {
    if (value?.trim() && !isNssValid(value)) {
      return setError(field, "NSS inválido");
    }
    clearError(field);
    return false;
  },

  curp: (value, field) => {
    if (value?.trim() && !isCURPValid(value)) {
      return setError(field, "CURP inválido");
    }
    clearError(field);
    return false;
  },

  birthdate: (value, field) => {
    if (value?.trim() && !isOlder(value)) {
      return setError(field, "Es menor de edad");
    }
    clearError(field);
    return false;
  },

  textUrl: (value, field) => {
    if (!value?.trim()) {
      return setError(field);
    }

    const regexUrl = /^\/|\/$/;
    if (regexUrl.test(value)) {
      return setError(field, "No se permite / al inicio y/o al final");
    }

    clearError(field);
    return false;
  },
};

// ======================
// Main function
// ======================
export const validateData = (
  { validate, data }: any,
  callback: (v: any) => void
): boolean => {
  let hasError = false;
  const _validate = { ...validate };

  Object.keys(data).forEach((key) => {
    const field = _validate[key];
    if (!field || !field.required) return;

    const validator = validators[field.type];
    if (validator) {
      hasError = validator(data[key], field) || hasError;
    }
  });

  callback(_validate);
  return hasError;
};



export const builderQueryParams = (values: any) => {
  if (Object.keys(values).length === 0 && values.constructor === Object)
    return "";
  let params: any = {};
  Object.keys(values).forEach((k) => {
    if (values[k]) {
      params[k] = values[k];
    }
  });
  return `?${new URLSearchParams(params).toString()}`;
};
export const formatDateDefault = (value: any, notSimbols?: any) => {
  if (!value) return "";
  if (notSimbols) return format(parseISO(value), "dd-MM-yyyy hh:mm");
  return format(parseISO(value), "dd-MM-yyyy hh:mm") + " hrs";
};
export const formatDateWithoutTime = (value: any, formatDate?: string) => {
  if (!value) return "";
  return format(parseISO(value), formatDate || "dd-MM-yyyy");
};
export const downloadURI = (uri: string, name: string) => {
  let link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export interface validateProps {
  schema: any;
  values: any;
}
export const validateForm = (parameters: validateProps): object => {
  const { schema, values } = parameters;
  try {
    let errores = {};
    for (let key in schema) {
      if (!values[key]) {
        if (!(schema[key].optional ? schema[key].optional : false)) {
          errores = {
            ...errores,
            [key]: schema[key].message || "Campo requerido",
          };
        }
      }
      if (values[key] && schema[key].pattern) {
        if (!values[key].toString().match(schema[key].pattern.regex)) {
          errores = {
            ...errores,
            [key]: schema[key].pattern.message || "Campo requerido",
          };
        }
      }
      if (values[key] && schema[key].validate) {
        let valid = schema[key].validate(values[key]);
        if (!valid.valid) {
          errores = {
            ...errores,
            [key]: valid.message,
          };
        }
      }
    }
    return errores;
  } catch (error) {
    return { error: "Error de configuración" };
  }
};

export const messagesLevel = (type: string, adicionales?: string): string => {
  let messages: any = {
    add: `Error al agregar ${adicionales}`,
    update: `Error al actualizar ${adicionales}`,
    read: `Error al obtener ${adicionales}`,
    delete: `Error al eliminar ${adicionales}`,
    unknown: "Error desconocido.",
    success: "La acción sé ha realizado con éxito",
    network: "Error de conexión",
  };

  return messages[type] || "Error desconocido";
};

export const randomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  return "#" + randomColor;
};

export const hotToast = (message: string, type: string, time?: number) => {
  toast.remove();
  switch (type) {
    case "SUCCESS":
      toast.success(message, {
        duration: 5000,
        position: "top-center",
        style: {
          border: "2px #3ea26a solid",
          color: "#707070",
          fontWeight: 500,
          fontSize: "16px",
          padding: "18px",
        },
        className: "",
        iconTheme: {
          primary: "#FFFFFF",
          secondary: "#3ea26a",
        },
      });
      break;
    case "ERROR":
      toast.error(message, {
        duration: 5000,
        position: "top-center",
        style: {
          border: "2px #D02e51 solid",
          color: "#707070",
          fontWeight: 500,
          fontSize: "16px",
          padding: "15px",
        },
        className: "",
        iconTheme: {
          primary: "#FFFFFF",
          secondary: "#D02e51",
        },
      });
      break;
    case "WAR":
      toast.error(message, {
        duration: time || 5000,
        position: "top-center",
        style: {
          border: "2px #ff9800 solid",
          color: "#707070",
          fontWeight: 500,
          fontSize: "16px",
          padding: "15px",
        },
        className: "",
        iconTheme: {
          primary: "#FFFFFF",
          secondary: "#ff9800",
        },
      });
      break;
  }
};

export const middlewareResponse = (Respose: ApiResponse<any>) => {
  const { data, ok } = Respose;
  if (ok) {
    const { code, message } = data;
    if (code !== 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    if (code === 0 && message) hotToast(message, "SUCCESS");
    return data.data;
  }
  data?.message && hotToast(data?.message, "ERROR");
  return null;
};

export function onKeyPressOnlyLetters(event: any) {
  let isValid =
    (event.charCode >= 65 && event.charCode <= 90) ||
    (event.charCode >= 97 && event.charCode <= 122);
  return isValid;
}

export function findInMenu(vista: any, modules: any[]) {
  // let res: boolean = false;
  // modules.forEach((item1: any) => {
  //   if (item1.idVista === vista.idVista) res = true;
  //   item1.hijos?.forEach((item2: any) => {
  //     if (item2.idVista === vista.idVista) res = true;
  //     item2.hijos?.forEach((item3: any) => {
  //       if (item3.idVista === vista.idVista) res = true;
  //     });
  //   });
  // });
  // return res;

  const findInChildren = (items: any[]): boolean => {
    return items.some(
      (item) =>
        item.idVista === vista.idVista ||
        (item.hijos && findInChildren(item.hijos))
    );
  };

  // Usar la función auxiliar para comprobar los módulos
  return findInChildren(modules);
}

export function checkValidJwt(jwt: string): boolean {
  if (!jwt) return false;
  const base64Clear = jwt.split(".")[1];
  const jsonText = Buffer.from(base64Clear, "base64").toString();
  const { exp } = JSON.parse(jsonText);
  const expired = exp < Date.now() / 1000;
  return !expired;
}

export const uniqueArray = (array: Array<any>) => {
  return array.filter(
    (obj, index, self) =>
      index === self.findIndex((o) => JSON.stringify(o) === JSON.stringify(obj))
  );
};

export function getIconForProfile({
  key,
  source,
  icon,
}: {
  key: string;
  source: any;
  icon: string;
}) {
  const { PUBLIC_URL } = process.env;
  if (!source) return `${PUBLIC_URL}/${icon}`;
  if (source[key]) return `${PUBLIC_URL}/${source[key]}`;
}

function uint8ArrayToBase64(uint8Array: any) {
  let binary = "";
  const len = uint8Array.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return window.btoa(binary);
}

export function compressString(str: string) {
  const utf8Array = new TextEncoder().encode(str);
  const compressed = pako.gzip(utf8Array);
  return uint8ArrayToBase64(compressed);
}

export function BuildMyReports(myModules: any[], reports: any[]) {
  if (!myModules || !reports) return [];

  const moduleWithIdVista3: any[] = myModules.find(
    (item) => item.idVista == 3
  ).hijos;

  if (!moduleWithIdVista3) return [];
  return reports
    .filter((vista) =>
      moduleWithIdVista3.some((module) => module.idVista === vista.idVista)
    )
    .map((vista) => {
      const hijos = Array.isArray(vista.hijos)
        ? vista.hijos.filter((hijo: any) => hijo.idVistaPadre === vista.idVista)
        : [];

      const hijosInModule = moduleWithIdVista3.find(
        (item) => item.idVista === vista.idVista
      )?.hijos;

      const nuevosHijos = Array.isArray(hijosInModule)
        ? hijos.filter((hijo: any) =>
          hijosInModule.some(
            (modHijo: any) => modHijo.idVista === hijo.idVista
          )
        )
        : [];

      return {
        ...vista,
        hijos: nuevosHijos,
      };
    });
}

export const BuildMenuReports = (myModules: any[]) => {

}
